import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['Tomar decisiones financieras inteligentes', 'Entender tu crédito sin confusión', 'Evitar errores que afectan tu score', 'Construir una base financiera sólida'];
  return <section className="py-20 bg-white" data-id="element-18">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-19">
        <motion.div className="bg-brand-green rounded-3xl p-8 md:p-12 shadow-premium" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-20">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-white mb-10" data-id="element-21">
            Lo que vas a lograr con este sistema
          </h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-22">
            {benefits.map((benefit, index) => <motion.div key={index} className="flex items-center gap-4 bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/10" initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} data-id="element-23">
                <CheckCircle2 className="w-8 h-8 text-brand-gold shrink-0" data-id="element-24" />
                <span className="text-lg font-medium text-white" data-id="element-25">
                  {benefit}
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}